<form class="form" [formGroup]="actForm" (keydown.enter)="NoEjecutarForm($event)">
    
    <div class="form-section-container">
        <h2>Actualizar datos de contacto y/o suscriptor</h2>
        <div class="w100">
            <mat-label>Autorizo a ESSA enviarme información a través de</mat-label>
            <div></div>
            <mat-radio-group aria-label="Seleccione una opción" [title]="tooltip_autNotificacion" formControlName="autNotificacion">
                <mat-radio-button value="CorreoElectronico" (change)="changeCorreoObligatorio($event)">Correo electrónico</mat-radio-button>
                <mat-radio-button value="Celular" (change)="changeCorreoObligatorio($event)">Celular</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="actForm.get('autNotificacion')?.invalid && actForm.get('autNotificacion')?.touched">
                <span *ngIf="actForm.get('autNotificacion')?.errors?.required">El campo es <strong>requerido</strong></span>
            </mat-error>
        </div>
        <div class="w100">
            <mat-label>¿Desea recibir factura de energía de manera digital?</mat-label>
            <div></div>
            <mat-radio-group aria-label="Seleccione una opción" formControlName="recibirFactElect" (change)="changeRecibirFactura($event)" [title]="tooltip_recibirFactElect">
                <mat-radio-button value="Si">Si</mat-radio-button>
                <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="actForm.get('recibirFactElect')?.invalid && actForm.get('recibirFactElect')?.touched">
                <span *ngIf="actForm.get('recibirFactElect')?.errors?.required">El campo es <strong>requerido</strong></span>
            </mat-error>
        </div>
         <div>
            <mat-form-field appearance="outline">
                <mat-label>Tipo de persona</mat-label>
                <mat-select formControlName="tipoPer" [title]="tooltip_tipoPer" (selectionChange)="onChangeTipoPer($event)">
                    <mat-option [value]="item.strCodigo" *ngFor="let item of TipoPerList">{{item.strDescripcion}}</mat-option>
                </mat-select>
                <div *ngIf="actForm.get('tipoPer')?.invalid && actForm.get('tipoPer')?.touched" class="ax-validaciones">
                    <span *ngIf="actForm.get('tipoPer')?.errors?.['required']">El campo es <strong>requerido</strong></span>
                </div>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Tipo de documento</mat-label>
                <mat-select formControlName="tipoDoc" [title]="tooltip_tipoDoc" (selectionChange)="onChangeTipoDoc($event)">
                    <mat-option [value]="item.strCodigo" *ngFor="let item of TipoDocFiltradoList">{{item.strDescripcion}}</mat-option>
                </mat-select>
                <div *ngIf="actForm.get('tipoDoc')?.invalid && actForm.get('tipoDoc')?.touched" class="ax-validaciones">
                    <span *ngIf="actForm.get('tipoDoc')?.errors?.['required']">El campo es <strong>requerido</strong></span>
                </div>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Primer nombre</mat-label>
                <input matInput autocomplete="off" name="nombre" id="nombre" maxlength="50" [title]="tooltip_nombre" formControlName="nombre">
                <mat-error *ngIf="actForm.get('nombre')?.invalid && actForm.get('nombre')?.touched">
                 <span *ngIf="actForm.get('nombre')?.errors?.required" >El campo es <strong>requerido</strong></span>
                 <span *ngIf="actForm.get('nombre')?.errors?.maxLength" >El valor supera los <strong>50 caracteres</strong></span>
                 <span *ngIf="actForm.get('nombre')?.errors?.pattern">El valor no puede incluir caracteres especiales</span>
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Segundo nombre</mat-label>
                <input matInput autocomplete="off" name="nombre1" id="nombre1" maxlength="50" [title]="tooltip_nombre1" formControlName="nombre1">
                <mat-error *ngIf="actForm.get('nombre1')?.invalid && actForm.get('nombre1')?.touched">
                 <span *ngIf="actForm.get('nombre1')?.errors?.maxLength" >El valor supera los <strong>50 caracteres</strong></span>
                 <span *ngIf="actForm.get('nombre1')?.errors?.pattern">El valor no puede incluir caracteres especiales</span>
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Primer apellido</mat-label>
                <input matInput autocomplete="off" name="apellido" id="apellido" maxlength="50" [title]="tooltip_apellido" formControlName="apellido">
                <mat-error *ngIf="actForm.get('apellido')?.invalid && actForm.get('apellido')?.touched">
                 <span *ngIf="actForm.get('apellido')?.errors?.required" >El campo es <strong>requerido</strong></span>
                 <span *ngIf="actForm.get('apellido')?.errors?.maxLength" >El valor supera los <strong>50 caracteres</strong></span>
                 <span *ngIf="actForm.get('apellido')?.errors?.pattern">El valor no puede incluir caracteres especiales</span>
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Segundo apellido</mat-label>
                <input matInput autocomplete="off" name="apellido1" id="apellido1" maxlength="50" [title]="tooltip_apellido1" formControlName="apellido1">
                <mat-error *ngIf="actForm.get('apellido1')?.invalid && actForm.get('apellido1')?.touched">
                 <span *ngIf="actForm.get('apellido1')?.errors?.maxLength" >El valor supera los <strong>50 caracteres</strong></span>
                 <span *ngIf="actForm.get('apellido1')?.errors?.pattern">El valor no puede incluir caracteres especiales</span>
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Razón social</mat-label>
                <input matInput autocomplete="off" name="razonSoc" id="razonSoc" maxlength="50" [title]="tooltip_razonSoc" formControlName="razonSoc">
                <mat-error *ngIf="actForm.get('razonSoc')?.invalid && actForm.get('razonSoc')?.touched">
                 <span *ngIf="actForm.get('razonSoc')?.errors?.maxLength" >El valor supera los <strong>50 caracteres</strong></span>
                 <span *ngIf="actForm.get('razonSoc')?.errors?.pattern">El valor no puede incluir caracteres especiales</span>
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Número de documento</mat-label>
                <input matInput autocomplete="off" (keypress)="SoloNumeros($event)" id="cedula" name="cedula"
                 formControlName="cedula" [title]="tooltip_cedula" maxLength="10">
                <mat-error *ngIf="actForm.get('cedula')?.invalid && actForm.get('cedula')?.touched">
                    <span *ngIf="actForm.get('cedula')?.errors?.required" >El campo es <strong>requerido</strong></span>
                    <span *ngIf="actForm.get('cedula')?.errors?.pattern">
                        Solo se permiten <strong>números</strong>
                        </span>
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Lugar de expedición (ciudad)</mat-label>
                <input matInput autocomplete="off" name="lugarExp" id="lugarExp" maxlength="50" [title]="tooltip_lugarExp" formControlName="lugarExp">
                <mat-error *ngIf="actForm.get('lugarExp')?.invalid && actForm.get('lugarExp')?.touched">
                 <span *ngIf="actForm.get('lugarExp')?.errors?.required" >El campo es <strong>requerido</strong></span>
                 <span *ngIf="actForm.get('lugarExp')?.errors?.maxLength" >El valor supera los <strong>50 caracteres</strong></span>
                 <span *ngIf="actForm.get('lugarExp')?.errors?.pattern">El valor no puede incluir caracteres especiales</span>
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Correo eléctronico</mat-label>
                <input matInput name="email" formControlName="correo" maxLength="60" [title]="tooltip_correo">
                <mat-error *ngIf="actForm.get('correo')?.invalid && actForm.get('correo')?.touched">
                    <span *ngIf="actForm.get('correo')?.errors?.emailStructure" >El <strong>correo</strong> no tiene el formato correcto</span>
                    <span *ngIf="actForm.get('correo')?.errors?.emailDomainTypo" >El <strong>dominio</strong> del correo parece incorrecto</span>
                    <span *ngIf="actForm.get('correo')?.errors?.emailInvalidTld" >El <strong>dominio</strong> del correo no es válido</span>
                    <span *ngIf="actForm.get('correo')?.errors?.emailDummy" >El <strong>correo</strong> ingresado no es válido</span>
                    <span *ngIf="actForm.get('correo')?.errors?.required">El campo es <strong>requerido</strong></span>
                   </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Celular</mat-label>
                <input matInput autocomplete="off" (keypress)="SoloNumeros($event)" id="celular" name="celular"
                formControlName="cel" [title]="tooltip_cel" maxlength="10">
                <mat-error *ngIf="actForm.get('cel')?.invalid && actForm.get('cel')?.touched">
                    <span *ngIf="actForm.get('cel')?.errors?.required" >El campo es <strong>requerido</strong></span>
                    <span *ngIf="actForm.get('cel')?.errors?.['minlength']" >El campo debe tener <strong>10 dígitos</strong></span>
                    <span *ngIf="actForm.get('cel')?.errors?.['consecutiveDigits']" >El campo debe contener un <strong>número válido</strong></span>
                    <span *ngIf="actForm.get('cel')?.errors?.pattern">
                        Solo se permiten <strong>números</strong>
                        </span>
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Teléfono</mat-label>
                <input matInput autocomplete="off" (keypress)="SoloNumeros($event)" id="telefono" name="telefono"
                formControlName="tel" [title]="tooltip_tel" maxlength="10">
                <mat-error *ngIf="actForm.get('tel')?.invalid && actForm.get('tel')?.touched">
                    <span *ngIf="actForm.get('tel')?.errors?.['minlength']" >Incluye el indicativo, el campo debe tener <strong>10 dígitos</strong></span>
                    <span *ngIf="actForm.get('tel')?.errors?.['consecutiveDigits']" >El campo debe contener un <strong>número válido</strong></span>
                    <span *ngIf="actForm.get('tel')?.errors?.pattern">
                        Solo se permiten <strong>números</strong>
                        </span>
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Dirección</mat-label>
                <input matInput autocomplete="off" name="direccion" id="direccion" formControlName="dir"
                [title]="tooltip_dir" maxLength="240">
                <mat-error *ngIf="actForm.get('dir')?.invalid && actForm.get('dir')?.touched">
                    <span *ngIf="actForm.get('dir')?.errors?.required">El campo es <strong>requerido</strong></span>
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Departamento</mat-label>
                <mat-select formControlName="depto" [title]="tooltip_depto" (selectionChange)="changeDepto($event)">
                    <mat-option [value]="item.strCodigo" *ngFor="let item of DeptoList">{{item.strDescripcion}}</mat-option>
                </mat-select>
                <div *ngIf="actForm.get('depto')?.invalid && actForm.get('depto')?.touched" class="ax-validaciones">
                    <span *ngIf="actForm.get('depto')?.errors?.['required']">El campo es <strong>requerido</strong></span>
                </div>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Municipio</mat-label>
                <mat-select formControlName="municipio" [title]="tooltip_municipio">
                    <mat-option [value]="item.strCodigo" *ngFor="let item of MunList">{{item.strDescripcion}}</mat-option>
                </mat-select>
                <div *ngIf="actForm.get('municipio')?.invalid && actForm.get('municipio')?.touched" class="ax-validaciones">
                    <span *ngIf="actForm.get('municipio')?.errors?.['required']">El campo es <strong>requerido</strong></span>
                </div>
            </mat-form-field>
        </div>
        
        <!-- <div>
            <mat-form-field>
                <mat-label>Propietario o arrendatario</mat-label>
                <mat-select>
                    <mat-option [value]="t.value" *ngFor="let t of Tipos">{{t.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div> -->
        <div class="w100">
            <mat-label>Propietario o arrendatario</mat-label>
            <div></div>
            <mat-radio-group aria-label="Seleccione una opción" [title]="tooltip_tipo" formControlName="tipo">
                <mat-radio-button value="Propietario" (change)="changeTipo($event)">Propietario</mat-radio-button>
                <mat-radio-button value="Arrendatario" (change)="changeTipo($event)">Arrendatario</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="actForm.get('tipo')?.invalid && actForm.get('tipo')?.touched">
                <span *ngIf="actForm.get('tipo')?.errors?.required">El campo es <strong>requerido</strong></span>
            </mat-error>
        </div>
        <div class="w100">
            <mat-label>¿Desea modificar el nombre de suscriptor de la factura de energía?</mat-label>
            <div></div>
            <mat-radio-group aria-label="Seleccione una opción" formControlName="modificarNomSusc" [title]="tooltip_modificarNomSusc">
                <mat-radio-button value="Si" (change)="changeModNomSus($event)">Si</mat-radio-button>
                <mat-radio-button value="No" (change)="changeModNomSus($event)">No</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="actForm.get('modificarNomSusc')?.invalid && actForm.get('modificarNomSusc')?.touched">
                <span *ngIf="actForm.get('modificarNomSusc')?.errors?.required">El campo es <strong>requerido</strong></span>
            </mat-error>
        </div>
        <div class="w100">
            <mat-label>¿Su porcentaje de propiedad es mayor o igual al 51%?</mat-label>
            <div></div>
            <mat-radio-group aria-label="Seleccione una opción" formControlName="porcPropMayor" [title]="tooltip_porcPropMayor">
                <mat-radio-button value="Si" (change)="changePorPropMayor($event)">Si</mat-radio-button>
                <mat-radio-button value="No" (change)="changePorPropMayor($event)">No</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="actForm.get('porcPropMayor')?.invalid && actForm.get('porcPropMayor')?.touched">
                <span *ngIf="actForm.get('porcPropMayor')?.errors?.required">El campo es <strong>requerido</strong></span>
            </mat-error>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Número de cuenta</mat-label>
                <input matInput autocomplete="off" (keypress)="SoloNumeros($event)" id="cuenta" name="cuenta"
                formControlName="numCuenta" [title]="tooltip_numCuenta" maxLength="12" (blur)='ValidarCuentaCliente($event)'>
                <mat-error *ngIf="actForm.get('numCuenta')?.invalid && actForm.get('numCuenta')?.touched">
                    <span *ngIf="actForm.get('numCuenta')?.errors?.required">El campo es <strong>requerido</strong></span>
                    <span *ngIf="actForm.get('numCuenta')?.errors?.pattern">
                        Solo se permiten <strong>números</strong>
                        </span>
                </mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Ficha Catastral:</mat-label>
                <input matInput autocomplete="off" name="matCat" id="matCat" (keypress)="SoloNumeros($event)" formControlName="matCatastral"
                [title]="tooltip_matCatastral" maxLength="30">
                <mat-error *ngIf="actForm.get('matCatastral')?.invalid && actForm.get('matCatastral')?.touched">
                    <span *ngIf="actForm.get('matCatastral')?.errors?.required">El campo es <strong>requerido</strong></span>
                    <span *ngIf="actForm.get('matCatastral')?.errors?.pattern">
                        Solo se permiten <strong>números</strong>
                        </span>
                </mat-error>
            </mat-form-field>
            <!-- <mat-form-field appearance="outline">
                <mat-label>Matrícula catastral:</mat-label>
                <app-custom-mat-cat name="matCat" id="matCat" formControlName="matCatastral"
                 [title]="tooltip_matCatastral" [disableField]="actForm.get('matCatastral').disabled"></app-custom-mat-cat>
                <mat-error *ngIf="actForm.get('matCatastral')?.invalid && actForm.get('matCatastral')?.touched">
                    <span *ngIf="actForm.get('matCatastral')?.errors?.required">El campo es <strong>requerido</strong></span>
                </mat-error>
              </mat-form-field> -->
        </div>
        
        <div>
            <mat-form-field appearance="outline">
                <mat-label>Medio por el cual conoció esta actualización</mat-label>
                <mat-select formControlName="medio" [title]="tooltip_medio">
                    <mat-option [value]="item.strCodigo" *ngFor="let item of MedioList">{{item.strDescripcion}}</mat-option>
                </mat-select>
                <div *ngIf="actForm.get('medio')?.invalid && actForm.get('medio')?.touched" class="ax-validaciones">
                    <span *ngIf="actForm.get('medio')?.errors?.['required']">El campo es <strong>requerido</strong></span>
                </div>
            </mat-form-field>
        </div>
        <!-- <div>
            <embed src="https://www.essa.com.co/site/Portals/0/documentos/transparencia-ita/ley-proteccion-de-datos/politica-de-proteccion-de-datos-personales-essa.pdf" width="100%" style="min-height: 70vh;">
        </div> -->
        <div class="w100">
            <p>Le informamos que al realizar el envio su solicitud por este medio, 
                estará aceptando que sus datos sean tratados de acuerdo al aviso de privacidad que se encuentra 
                en el siguiente link <a [href]="urlPolPriv" target="_blank">Consulte aquí.</a></p>
            <mat-checkbox [title]="tooltip_aceptaTratDatosPer" formControlName="aceptaTratDatosPer">Acepto</mat-checkbox>
            <mat-error *ngIf="submitted && actForm.get('aceptaTratDatosPer')?.errors">
                <span>El campo es <strong>requerido</strong></span>
            </mat-error>
        </div>
        <div class="w100">
            <ngx-recaptcha2 [siteKey]="siteKey" formControlName="recaptcha"></ngx-recaptcha2>
            <mat-error *ngIf="actForm.get('recaptcha')?.invalid && actForm.get('recaptcha')?.touched">
                <span *ngIf="actForm.get('recaptcha')?.errors?.required">Debes completar el 
                    <strong>captcha</strong> de seguridad</span>
            </mat-error>
        </div>
        <div>
            <button (click)="SolicitudSubmit()" [attr.disabled]="btnDisEnviar" [title]="tooltip_enviar" mat-raised-button class="ax-btn-enviar">Enviar</button>
        </div>
    </div>
</form>